import { IApplicationState } from '../../types/redux';

export function getBackgroundVideo(state: IApplicationState) {
  return state.newbuilding.backgroundVideo;
}
